export default "__VITE_ASSET__BSnJ1cBe__"